import React from 'react';
import { MemberEntity } from '../../models';

interface MemberDetailContextType {
  member: MemberEntity | null;
  memberId: number;
}

export const MemberDetailContext = React.createContext<MemberDetailContextType>({} as MemberDetailContextType);
